// This file is auto-generated by Kubb. Do not edit manually.
/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";

import { errorSchema } from "./errorSchema.ts";
import { shortCodeContextSchema } from "./shortCodeContextSchema.ts";

export const getShortCodePathParamsSchema = z.object({
  code: z.string().describe("The short code to resolve"),
});

/**
 * @description Short code resolved successfully
 */
export const getShortCode200Schema = z.lazy(() => shortCodeContextSchema);

/**
 * @description Invalid code parameter
 */
export const getShortCode400Schema = z.lazy(() => errorSchema);

/**
 * @description Unauthorized
 */
export const getShortCode401Schema = z.lazy(() => errorSchema);

/**
 * @description Forbidden
 */
export const getShortCode403Schema = z.lazy(() => errorSchema);

/**
 * @description Short code not found
 */
export const getShortCode404Schema = z.lazy(() => errorSchema);

/**
 * @description Method not allowed
 */
export const getShortCode405Schema = z.lazy(() => errorSchema);

/**
 * @description Internal server error
 */
export const getShortCode500Schema = z.lazy(() => errorSchema);

export const getShortCodeQueryResponseSchema = z.lazy(
  () => getShortCode200Schema,
);
